import PropTypes from 'prop-types';
import extractText from '../../utils/extractText';
export default (function (_ref) {
  var storeParams = _ref.storeParams,
    storeValue = _ref.storeValue,
    basePath = _ref.basePath,
    resolverMap = _ref.resolverMap,
    transformerMap = _ref.transformerMap;
  // Not using default props because this function can be called without using React or JSX
  var Text = function Text() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _props$path = props.path,
      localPath = _props$path === void 0 ? '' : _props$path,
      _props$params = props.params,
      localParams = _props$params === void 0 ? {} : _props$params,
      _props$resolvers = props.resolvers,
      resolverIds = _props$resolvers === void 0 ? [] : _props$resolvers,
      _props$transformers = props.transformers,
      transformerIds = _props$transformers === void 0 ? [] : _props$transformers,
      _props$custom = props.custom,
      custom = _props$custom === void 0 ? {} : _props$custom;
    return extractText({
      storeParams: storeParams,
      localParams: localParams,
      storeValue: storeValue,
      basePath: basePath,
      localPath: localPath,
      resolverMap: resolverMap,
      transformerMap: transformerMap,
      resolverIds: resolverIds,
      transformerIds: transformerIds,
      custom: custom
    });
  };
  Text.propTypes = {
    path: PropTypes.string,
    params: PropTypes.shape({}),
    resolvers: PropTypes.arrayOf(PropTypes.string),
    transformers: PropTypes.arrayOf(PropTypes.string),
    custom: PropTypes.shape({})
  };
  return Text;
});